import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#8b7d6f] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-light mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              게임 코어루프 연구소
            </h3>
            <p className="text-sm text-white/80 leading-relaxed">
              히트작의 핵심을 분석하고 다음 성공을 예측하는 게임 개발 인사이트 플랫폼
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-light mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              바로가기
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate('/board/core-loop')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  히트 코어루프
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/board/fast-follower')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  패스트 팔로워
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/board/idea-archive')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  해든의 코어루프 아이디어
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/board/hit-prediction')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  히트 가능성 예측 리포트
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-light mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              법적 고지
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate('/privacy')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  개인정보처리방침
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/terms')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  이용약관
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/contact')}
                  className="text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  문의하기
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/60">
            © 2026 게임 코어루프 연구소. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/60 hover:text-white/80 transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
